export default __webpack_public_path__ + "static/media/play-left.de55c556.svg";